export default __webpack_public_path__ + "static/media/uea.8f462dda.svg";